/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query AccountQuery {
        music_viewer {
            me {
                id
                email
            }
        }
    }
`;